function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.71875 11.0235L16 10.0235V6.87505C16 6.54692 16.1602 6.30083 16.4805 6.05474C16.8008 5.97271 17.1211 5.97271 17.3594 6.13677C20.6406 8.43364 23.7617 12.2813 23.8398 12.4454C23.918 12.6016 23.9922 12.836 23.9961 13C23.9961 13.004 24 13.0118 24 13.0157C24 13.1797 23.9219 13.4258 23.8398 13.5079C23.7617 13.6719 20.7188 17.5313 17.3594 19.8282C17.0391 19.9922 16.7188 20.0743 16.4805 19.9102C16.1602 19.7461 16 19.5 16 19.1719V16.0235L2.71875 15.0235C2.32031 14.7032 2 13.8985 2 13.0157C2 12.2188 2.23828 11.3438 2.71875 11.0235Z",
  fill: "#7A69BF"
});

const SvgMoveArrow = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoveArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/move-arrow.ca2cf4a2.svg";
export { ForwardRef as ReactComponent };